/**
 * Created by Administrador on 16/05/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('revenuePlanningConnections',{
                parent: 'app',
                url: '/revenuePlanning/connectionsItinerary/:id',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/revenue/revenuePlanning/revenuePlanningConnection/revenuePlanningConnections.html',
                        controller: 'revenuePlanningConnectionCtrl',
                        controllerAs: 'vm',
                        'resolve': {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['revenuePlanning']);
                            }],
                            'tabRevenue': ['tabService', function(tabService){
                                return tabService.getTabRevenue('itineraryListRevenue')
                            }],
                            categories: ['tariffClassService',function(tariffClassService){
                                return tariffClassService.getFareClassesFare();
                            }],
                            itineraryConnections: ['itineraryConnectionService','$stateParams',
                            function(itineraryConnectionService,$stateParams){
                                return itineraryConnectionService.getItineraryConnections($stateParams.id,$stateParams.page,$stateParams.size);
                            }]
                        }
                    }
                }
            })
    }
})();


